export default __webpack_public_path__ + "static/media/sleep.33c35074.svg";